import { useQuery } from '@tanstack/react-query';
import { Navigate, Outlet } from 'react-router-dom';
import { authService, hasSalesProduct } from '../lib/auth';

export function ProductHome() {
  const status = useQuery({queryKey:['auth-status'],queryFn:authService.status,enabled:false});
  return <Navigate to={hasSalesProduct(status.data?.user) ? '/overview' : '/video-workshop'} replace />;
}

export function RequireSalesProduct() {
  const status = useQuery({queryKey:['auth-status'],queryFn:authService.status,enabled:false});
  return hasSalesProduct(status.data?.user) ? <Outlet /> : <Navigate to="/video-workshop" replace />;
}
